class AddThis {
  constructor() {
    this._enabled = false;
    this._addthis = null;
    this._calls = [];
  }

  // asyncronously download the addthis code
  load(code, sourceUrl) {
    if (!code || code === 'no' || this._enabled) { return; }
    this._sourceUrl = sourceUrl;
    this._enabled = true;
    const el = document.createElement('script');
    el.type = 'text/javascript';
    el.async = 'async';
    el.onload = this._onLoad.bind(this);
    el.src = `//s7.addthis.com/js/300/addthis_widget.js#pubid=${code}`;
    document.getElementsByTagName('head')[0].appendChild(el);
  }

  refresh() {
    this._calls.push(['refresh']);
    this._flush();
  }

  onRender(callback) {
    this._calls.push(['addEventListener', 'addthis.layer.rendered', callback]);
    this._flush();
  }

  url(id, station) {
    let url = this._sourceUrl || document.location.href;
    if (url.indexOf('?') > 0) {
      url += '&';
    } else {
      url += '?';
    }
    url += `futurishared=${id}&station=${station}`;
    return url;
  }

  // called when the script tag finishes downloading
  _onLoad() {
    window.addthis.addEventListener('addthis.layers.ready', () => {
      this._addthis = window.addthis;
      this._flush();
    });
  }

  // flushes calls to addthis that may have been queued up while the
  // script loads
  _flush() {
    if (this._enabled && !this._addthis) { return; }
    const calls = this._calls;
    this._calls = [];
    if (!this._enabled) { return; }

    calls.forEach((args) => {
      const method = args.shift();
      if (method === 'refresh') {
        this._addthis.layers.refresh();
      } else {
        this._addthis[method].apply(this._addthis, args);
      }
    });
  }
}

export default new AddThis();



// WEBPACK FOOTER //
// ./src/addthis.js